import { useEffect, useState } from 'react';
import Cal, { getCalApi } from "@calcom/embed-react";
import Modal from './Modal';

interface CalendarPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CalendarPopup({ isOpen, onClose }: CalendarPopupProps) {
  const [calApiReady, setCalApiReady] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    let isMounted = true;

    (async function () {
      try {
        const cal = await getCalApi({
          embedJsUrl: "https://cal.eu/embed/embed.js"
        });
        if (isMounted) {
          cal("ui", {
            cssVarsPerTheme: {
              light: { "cal-brand": "#B8806F" },
              dark: { "cal-brand": "#F0E4DF" }
            },
            hideEventTypeDetails: false,
            layout: "month_view"
          });
          setCalApiReady(true);
        }
      } catch (error) {
        console.error("Erreur d'initialisation Cal.com:", error);
        if (isMounted) setCalApiReady(true);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showHeader={false}
      maxWidth="max-w-[769px]"
      maxHeight="h-[922px] max-h-[95vh]"
      zIndex="z-[9999]"
      ariaLabel="Réserver un rendez-vous"
    >
      {!calApiReady && (
        <div className="absolute inset-0 flex items-center justify-center bg-white dark:bg-warm-gray-900 z-[5]">
          <div className="flex flex-col items-center gap-4">
            <div className="w-10 h-10 border-4 border-aurore-light border-t-aurore-dark rounded-full animate-spin"></div>
            <p className="text-warm-gray-600 text-sm">Chargement du calendrier...</p>
          </div>
        </div>
      )}

      <Cal
        calLink="aurorerh"
        calOrigin="https://cal.eu"
        style={{
          width: "100%",
          height: "100%",
          overflow: "auto",
          opacity: calApiReady ? 1 : 0,
          transition: "opacity 0.3s ease"
        }}
        config={{
          layout: "month_view",
          useSlotsViewOnSmallScreen: "true"
        }}
      />
    </Modal>
  );
}
